// Pages that own their own scrolling and must fill the viewport exactly on
// desktop (graph canvas + chat panes). The layout wrappers turn into a fixed
// height flex column only for these paths; every other page grows tall and lets
// the ReactWrapper shell scroll, so constraining them would clip their content
// to one viewport with no scroller of its own.
export const FULL_HEIGHT_PATHS = ['/react/octopus']

export const isFullHeightPath = (pathname: string) =>
  FULL_HEIGHT_PATHS.some((path) => pathname.startsWith(path))
